

export enum RoleDomain {
  ORG = 'ORG',
  HRM = 'HRM',
  PMO = 'PMO',
  CRM = 'CRM',
  EMPLOYEE = 'EMPLOYEE',
}

export enum RoleLevel {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  USER = 'USER',
  EMPLOYEE = 'EMPLOYEE',
  NONE = 'NONE',
}

export type HrRoleOptions =
  | 'NONE'
  | 'EMPLOYEE'
  | 'MANAGER'
  | 'ADMIN';

  export type RoleOptions =
  | 'NONE'
  | 'USER'
  | 'MANAGER'
  | 'ADMIN';


export type UserRole =
  | 'ORG_OWNER'
  | 'ORG_ADMIN'
  | 'HRM_ADMIN'
  | 'HRM_MANAGER'
  | 'HRM_EMPLOYEE'
  | 'PMO_ADMIN'
  | 'PMO_MANAGER'
  | 'PMO_USER'
  | 'CRM_ADMIN'
  | 'CRM_MANAGER'
  | 'CRM_USER'
  | 'EMPLOYEE'
  | 'NONE';

  export type User_Role =
  | 'OWNER'
  | 'ADMIN'
  | 'ADMIN'
  | 'MANAGER'
  | 'EMPLOYEE'
  | 'ADMIN'
  | 'MANAGER'
  | 'USER'
  | 'ADMIN'
  | 'MANAGER'
  | 'USER'
  | 'EMPLOYEE'
  | 'NONE';


export type UserStatus = 'Active' | 'Suspended' | 'Invite Sent';

// export interface User {
//   id: string;
//   name: string;
//   email: string;
//   avatar: string;
//  roleList:UserRole[];
//   lastActive: string;
//   status: UserStatus;
// }

export interface User {
  status: boolean;
  appUserUuid:string;
  email:string;
  firstName:string;
  lastName:string;
  roleList: UserRole[];
  orgUuid:string;
  isOrgOnboarded:boolean;
  isUserJoined:boolean;
  lastLoggedInAt?:string;
  lastActiveAt?:string;
  isUserActive?:boolean;
  joiningMailSentAt?:string;
  profileImageURL?:string;
  contactNumber?:string;
  projectUuidList?:string[];
}

export const ROLE_LABEL_MAP: Record<UserRole, string> = {
  ORG_OWNER: "Org Owner",
  ORG_ADMIN: "Org Admin",

  HRM_ADMIN: "HR Admin",
  HRM_MANAGER: "HR Manager",
  HRM_EMPLOYEE: "HR Employee",

  PMO_ADMIN: "PM Admin",
  PMO_MANAGER: "PM Manager",
  PMO_USER: "PM User",

  CRM_ADMIN: "CRM Admin",
  CRM_MANAGER: "CRM Manager",
  CRM_USER: "CRM User",

  EMPLOYEE: "Employee",
  

  NONE: "None",
};




export interface EditingUser {
  id: string;
  hrmsRole: UserRole;
  projectManagementRole: UserRole;
  crmRole: UserRole;
  projectUuidList?: string[];
}